import { Suspense, lazy, memo } from 'react';

import type { HeaderOptions } from './model';
import { HeaderOptionsProvider } from './model';

const Header = lazy(() => import('./components/Header'));
const CompetitionHeader = lazy(() => import('./components/CompetitionHeader'));

export const App = ({ options }: { options: HeaderOptions }) => {
  return (
    <HeaderOptionsProvider options={options}>
      <Suspense>{options.isCompetitionContext ? <CompetitionHeader /> : <Header />}</Suspense>
    </HeaderOptionsProvider>
  );
};

export default memo(App);
